// extracted by mini-css-extract-plugin
export var active = "_38-9";
export var backButton = "_38-8";
export var clone = "_38-e";
export var collapseBar = "_38-k";
export var collapseMode = "_38-m";
export var collapsed = "_38-o";
export var dimmed = "_38-i";
export var dragHandle = "_38-c";
export var dropdownIcon = "_38-g";
export var expanding = "_38-n";
export var hidden = "_38-x";
export var iconContainer = "_38-q";
export var iconSwapper = "_38-w";
export var navItem = "_38-6";
export var navItemIcon = "_38-f";
export var navProfile = "_38-7";
export var notificationCountBadge = "_38-j";
export var notificationDot = "_38-r";
export var optionsContainer = "_38-h";
export var primaryNav = "_38-0";
export var primaryNavDivider = "_38-v";
export var primaryNavResizeHandle = "_38-2";
export var primaryNavResizing = "_38-1";
export var primaryNavTabSection = "_38-u";
export var primaryTab = "_38-p";
export var primaryTabIconBox = "_38-s";
export var secondaryNav = "_38-3";
export var selected = "_38-t";
export var settingsNav = "_38-4";
export var settingsNavItems = "_38-5";
export var show = "_38-d";
export var sideNav = "_38-l";
export var teamItem = "_38-a";
export var userProfileItem = "_38-b";